module.exports = __webpack_public_path__ + "static/media/wtb3.7e428ffd.jpg";